export default __webpack_public_path__ + "static/media/Cloudxier_graphics-each-expertise-01.444d5814.png";